export class UiStateList {
  public changePasswordForUser = "main.usermanagement.changepassword";
  public commercialCustomerCapture = "main.commercialCustomerCapture";
  public communityPaymentCapture = "main.communityPaymentCapture";
  public costCalculation = "main.costCalculation";
  public createCustomer = "main.customercreate";
  public editCustomer = "main.customeredit";
  public creditCheck = "main.customercreditcheck";
  public editGroup = "main.usermanagement.editgroup";
  public editPartner = "main.usermanagement.editpartner";
  public editRole = "main.usermanagement.editrole";
  public editUser = "main.usermanagement.edituser";
  public invoices = "main.invoices";
  public manageEpcAssumedValue = "main.costCalculationAssumedValues";
  public searchCustomers = "main.customersearch";
  public searchGroups = "main.usermanagement.search.groups";
  public searchPartner = "main.usermanagement.search.partners";
  public searchRoles = "main.usermanagement.search.roles";
  public searchUsers = "main.usermanagement.search.users";
  public trinityPaymentCapture = "main.trinityPaymentCapture";
  public updatePaymentMethod = "main.updatePaymentMethod";
  public updatePaymentMethodCustomer = "main.updatePaymentMethodCustomer";
  public viewCustomerDetails = "main.customer";
  public editIssues = "main.upsertIssue";
  public createIssues = "main.issueCreate";
  public allIssues = "main.allIssues";
  public manageReferenceValues = "main.admin.managereferencevalues";
  public manageComponents = "main.admin.manageComponents";
}
